module.exports = __webpack_public_path__ + "img/ashby.7dbcc2b8.png";